import { render, staticRenderFns } from "./OrgLicense.vue?vue&type=template&id=5e15e3b4&"
import script from "./OrgLicense.vue?vue&type=script&lang=js&"
export * from "./OrgLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports